import { api } from '../../DefaultService';
import type { IFaceSyncAsyncCreateResponseProps } from 'services/Jobs/types';
import {
  ICustomerRecognitionCreateProps,
  ICustomerRecognitionProps,
  ICustomerRecognitionUpdateParams,
} from './types';

const ENDPOINT = 'v1/recognitions/customers';

export const createCustomerRecognitionAsync = async (
  data: ICustomerRecognitionCreateProps,
): Promise<ICustomerRecognitionProps> => {
  return await api
    .post(`${ENDPOINT}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const createCustomerRecognitionAsyncJob = async (
  data: ICustomerRecognitionCreateProps,
): Promise<IFaceSyncAsyncCreateResponseProps> => {
  return await api
    .post(`${ENDPOINT}/async`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const updateCustomerRecognitionAsync = async ({
  id,
  data,
}: ICustomerRecognitionUpdateParams): Promise<ICustomerRecognitionProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const updateCustomerRecognitionAsyncJob = async ({
  id,
  data,
}: ICustomerRecognitionUpdateParams): Promise<IFaceSyncAsyncCreateResponseProps> => {
  return await api
    .put(`${ENDPOINT}/${id}/async`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 0,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const deleteCustomerRecognitionAsyncJob = async (
  id: number,
): Promise<IFaceSyncAsyncCreateResponseProps> => {
  return await api
    .delete(`${ENDPOINT}/${id}/async`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getCustomerRecognitionByIdAsync = async (
  id: number,
): Promise<ICustomerRecognitionProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};
